"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _default = (0, _createSvg.createSvg)('IconDisabled', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M15.6039211,5.81029248 L5.81029248,15.6039211 C6.97933765,16.4802797 8.43026749,17 10,17 C13.859,17 17,13.859 17,10 C17,8.43026749 16.4802797,6.97933765 15.6039211,5.81029248 Z M14.1897075,4.39607891 C13.0206624,3.51972031 11.5697325,3 10,3 C6.141,3 3,6.141 3,10 C3,11.5697325 3.51972031,13.0206624 4.39607891,14.1897075 L14.1897075,4.39607891 Z M10,1 C14.963,1 19,5.037 19,10 C19,14.963 14.963,19 10,19 C5.037,19 1,14.963 1,10 C1,5.037 5.037,1 10,1 Z'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
})));

exports.default = _default;